export enum FileLogAction {
  FileUploaded = "File Uploaded",
  FileApproved = "File Approved",
  FileDeclined = "File Declined",
  NoteAdded = "Note Added",
}
